import { getApiUrl } from './common';

/** *
 * this is mutable object so changing it effects all fetches for this method, handle with care!
 */
export function setMethodMutableOverride(methodConfig, override) {
  const prevValue = methodConfig._mutableOverride;
  methodConfig._mutableOverride = override;
  return prevValue;
}
export function getMethodMutableOverride(methodConfig) {
  return methodConfig._mutableOverride;
}
export function removeMethodMutableOverride(methodConfig) {
  const prevValue = methodConfig._mutableOverride;
  delete methodConfig._mutableOverride;
  return prevValue;
}

/**
 * this is mutable object so changing it effects all queryFn for this method, mostly designed for intercepting queryFn calls
 * handle with care
 */

const globalWindowFallbackObj = {};
const getSharedMutableFetchMiddleware = () => {
  const isNodeEnv = typeof window === 'undefined';
  const windowObj = isNodeEnv ? globalWindowFallbackObj : window;
  if (!windowObj.PremiumSharedMutableFetchMiddleware) {
    windowObj.PremiumSharedMutableFetchMiddleware = {
      middlewares: {}
    };
  }
  return windowObj.PremiumSharedMutableFetchMiddleware;
};
const MutableMethodsFetchMiddleware = getSharedMutableFetchMiddleware();
export function setMutableMethodMiddleware(methodConfig, middleware) {
  var _middleware;
  if (middleware === void 0) {
    middleware = null;
  }
  const key = getApiUrl(methodConfig);
  MutableMethodsFetchMiddleware.middlewares[key] = (_middleware = middleware) != null ? _middleware : undefined;
}
export function removeMutableMethodMiddleware(methodConfig) {
  setMutableMethodMiddleware(methodConfig, undefined);
}
export function getMutableMethodMiddleware(methodConfig) {
  var _MutableMethodsFetchM;
  const key = getApiUrl(methodConfig);
  return (_MutableMethodsFetchM = MutableMethodsFetchMiddleware.middlewares[key]) != null ? _MutableMethodsFetchM : undefined;
}
//# sourceMappingURL=internal.js.map